import React, { ReactNode, Suspense } from 'react';
import { Transition } from 'react-transition-group';
import { Spinner } from 'components/circleSpinner/Spinner';
import Cross from '../../../assets/Cat-Entity/Icon_Modal_Cross.png';
import ErrorBoundary from 'components/page/ErrorBoundary';
import ErrorFallback from 'components/fallbacks/ErrorFallback';

export interface RightPanelProps {
    rightPanelContent: boolean | null;
    closePanel(): void;
    title?: string;
    children?: ReactNode;
}

const RightPanel: React.FC<RightPanelProps> = ({
    children,
    rightPanelContent,
    closePanel,
    title = 'Right panel',
}) => {
    
    return (
        <Transition in={!!rightPanelContent} timeout={100} mountOnEnter unmountOnExit>
            {(transitionState) => (
                <>
                    <div
                        className={'RightPanelUnderlay ' + transitionState}
                        onMouseDown={closePanel}
                    />
                    <div className={'RightPanel ' + transitionState}>
                        <div className="Inner">
                            <div className="Top">
                                <h2 className="Title">{title}</h2>
                                <div className="Cross">
                                    <img src={Cross} alt="Cross" onClick={closePanel} />
                                </div>
                            </div>
                            <Suspense fallback={<Spinner />}>
                                <ErrorBoundary fallback={<ErrorFallback />}>
                                    {children ?? null}
                                </ErrorBoundary>
                            </Suspense>
                        </div>
                    </div>
                </>
            )}
        </Transition>
    );
};

export { RightPanel };
